import { render } from "./EmployeeDetails.vue?vue&type=template&id=e29d8d52&scoped=true"
import script from "./EmployeeDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeDetails.vue?vue&type=script&lang=js"

import "./EmployeeDetails.vue?vue&type=style&index=0&id=e29d8d52&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29d8d52"]])

export default __exports__